import { useState } from "react";
import { Link } from "react-router";
import { temPapel, useAuth } from "../lib/auth";
import { mensagemDeErro } from "../lib/rpc";
import { conectarTiny, pedeReconectar, type ConexaoTiny } from "../lib/tinyConexao";

/**
 * Faixa de aviso da conexão com o Tiny (painel e topo das telas do admin). Não aparece com a
 * conexão em dia. O admin reconecta dali mesmo; os outros veem para avisar o admin.
 */
export function AvisoTiny({ conexao, linkIntegracao = true }: { conexao: ConexaoTiny | null | undefined; linkIntegracao?: boolean }) {
  const { perfil } = useAuth();
  const [erro, setErro] = useState<string | null>(null);
  if (!conexao || conexao.situacao === "conectado") return null;
  const admin = temPapel(perfil, "admin");
  const desconectado = conexao.situacao === "desconectado";

  return (
    <div role="alert" className={`flex flex-wrap items-center gap-3 rounded-md border-2 px-4 py-3 print:hidden ${
      desconectado ? "border-erro bg-erro-claro text-erro" : "border-alerta bg-alerta-claro text-tinta"}`}>
      <div className="flex min-w-0 flex-1 flex-col gap-1">
        <span className="font-sinal text-lg font-bold">
          {desconectado ? "Tiny desconectado: pedidos novos e documentos param" : "Conexão com o Tiny precisa de atenção"}
        </span>
        <span className="text-sm text-tinta">{conexao.mensagem}</span>
        {!admin && <span className="text-sm font-semibold text-tinta">Avise o administrador do WMS.</span>}
        {erro && <span className="text-sm font-semibold">{erro}</span>}
      </div>
      {admin && (
        <div className="flex flex-wrap gap-2">
          {pedeReconectar(conexao) && (
            <button type="button" onClick={() => { setErro(null); conectarTiny().catch((e) => setErro(mensagemDeErro(e))); }}
              className="min-h-11 rounded-md bg-tinta px-4 font-semibold text-white hover:opacity-90">Reconectar</button>
          )}
          {linkIntegracao && (
            <Link to="/admin/integracao" className="flex min-h-11 items-center rounded-md border-2 border-tinta px-4 font-semibold text-tinta">
              Abrir Integração
            </Link>
          )}
        </div>
      )}
    </div>
  );
}
